/***
 * Created on 2024/10/1
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/

import React from 'react';
import ModalDialog from "../../common/modal_dialog/modalDialog";
import {useTranslation} from "react-i18next";

function ChinaAddPhoneStep3({state, dispatch, ...props}) {
    const { t } = useTranslation();

    const getSubmitName = () => {
        const url = new URL(location.href);
        let client_id;
        client_id = url.searchParams.get('client_id');
        if (!client_id && url.searchParams.get("state")) {
            const state = new URLSearchParams(decodeURIComponent(url.searchParams.get("state")));
            client_id = state.get('client_id');
        }
        if (client_id) {
            const apps = sessionStorage.getItem('apps');
            if (apps) {
                const data = JSON.parse(apps);
                if (data?.[client_id]) {
                    return `${t('@Back to@')} ${data[client_id].display_name}`;
                }
            }
        }
        return t('OK');
    }

    const onOk = () => {
        const searchParams = new URLSearchParams(window.location.search);
        if (searchParams.has('state')) {
            location.href = searchParams.get('state').toString()
        }
        else {
            location.href = '/profile/account';
        }
    }

    return (
        <ModalDialog {...props} title={t("@Add Your Phone Number@")} hideCancel={true} submitAction={onOk} submitText={getSubmitName()}>
            <div className="dialog-content">
                <p>
                    {t('@Thank you for your understanding. You have successfully added your phone number to this QNAP account. You can now use it to sign in any QNAP cloud services.@')}
                </p>
            </div>

        </ModalDialog>
);
}

export default ChinaAddPhoneStep3;